export enum PreferredLocale {
  ar = "ar",
  de = "de",
  en = "en",
  es = "es",
  fr = "fr",
  fr_ca = "fr-ca",
  hi = "hi",
  ind = "ind",
  it = "it",
  jp = "jp",
  kh = "kh",
  ko = "ko",
  la = "la",
  ms = "ms",
  pa = "pa",
  pt = "pt",
  ru = "ru",
  th = "th",
  tl = "tl",
  vi = "vi",
  zh_cn = "zh-cn",
  zh_hant = "zh-hant",
}

export const LocaleNames = {
  [PreferredLocale.ar]: "Arabic",
  [PreferredLocale.ind]: "Bahasa Indonesian",
  [PreferredLocale.zh_cn]: "Chinese (Simplified)",
  [PreferredLocale.zh_hant]: "Chinese (Traditional)",
  [PreferredLocale.en]: "English",
  [PreferredLocale.fr_ca]: "French (Canada)",
  [PreferredLocale.fr]: "French",
  [PreferredLocale.de]: "German",
  [PreferredLocale.hi]: "Hindi",
  [PreferredLocale.it]: "Italian",
  [PreferredLocale.jp]: "Japanese",
  [PreferredLocale.kh]: "Khmer",
  [PreferredLocale.ko]: "Korean",
  [PreferredLocale.la]: "Laotian",
  [PreferredLocale.ms]: "Malay",
  [PreferredLocale.pt]: "Portuguese",
  [PreferredLocale.pa]: "Punjabi",
  [PreferredLocale.ru]: "Russian",
  [PreferredLocale.es]: "Spanish",
  [PreferredLocale.tl]: "Tagalog",
  [PreferredLocale.th]: "Thai",
  [PreferredLocale.vi]: "Vietnamese",
};
